import { FC } from 'react';

import { CategoryGetResponse, SubcategoryResponse } from '../../category/model/categoryModel';
import Subcategories from '../Subcategories';
import { useGetCategoriesQuery } from '../../category/api/categoryApi';

import './groupCategories.scss';

const groupCategories = (categories: CategoryGetResponse[], subcategories: SubcategoryResponse[]) => {
  return categories.filter((category) => {
    return subcategories.find((subcategory) => {
      return category.id === subcategory.id;
    });
  });
};

interface GroupCategoriesProps {
  subcategories: SubcategoryResponse[];
}

const GroupCategories: FC<GroupCategoriesProps> = (props) => {
  const { data: categories, isSuccess } = useGetCategoriesQuery({});

  return (
    <div className="GroupCategories-Wrapper">
      {isSuccess &&
        groupCategories(categories, props.subcategories)
          .sort((a, b) => a.name.localeCompare(b.name))
          .map(({ iri, name, subcategories }) => {
            return (
              <div key={iri}>
                <h3>{name}</h3>
                <Subcategories subcategories={subcategories} />
              </div>
            );
          })}
    </div>
  );
};

export default GroupCategories;
